import styled from 'styled-components';
import Theme from '../theme';
import { remCalc } from '@lux/helpers';

// List of HTML elements that do not need to be converted to ReactComponents
// using htmlStringToReactComponent
// These are ones we consider unneccesary to create a new LUX component for
// and so a small styled-component is sufficient.

export const HorizontalRule = styled.hr`
  border: solid ${Theme.colours.grey_dd};
  border-width: 1px 0 0;
  clear: both;
  height: 0;
  margin: ${remCalc(20)} 0;
`;

export const Paragraph = styled.p`
  ${Theme.fonts.styles.BodyCopy};
  line-height: 1.5;
  margin-bottom: ${remCalc(20)};
  letter-spacing: ${remCalc(0.16)};
`;
